<div class="header__reveal-zone" aria-hidden="true" (mouseenter)="setRevealed(true)"></div>

<header
  class="header"
  [class.header--scrolled]="scrolled()"
  [class.header--menu-open]="menuOpen()"
  (mouseleave)="setRevealed(false)"
>
  <div class="header__inner container">
    <a class="header__brand" routerLink="/" aria-label="EVRN home" (click)="closeMenu()">
      <img class="header__logo" src="/assets/hero/logotype.svg" alt="EVRN" />
    </a>

    <button
      class="header__burger"
      type="button"
      [class.header__burger--open]="menuOpen()"
      [attr.aria-expanded]="menuOpen()"
      aria-label="Toggle navigation menu"
      (click)="toggleMenu()"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <nav class="header__nav" [class.header__nav--open]="menuOpen()" aria-label="Main navigation">
      <div class="header__links">
        @for (item of navItems; track item.label) {
          @if (item.type === 'internal') {
            <a
              class="header__link type-label-l2"
              [routerLink]="item.routerLink"
              [fragment]="item.fragment"
              (click)="closeMenu()"
            >
              {{ item.label }}
            </a>
          } @else {
            <a
              class="header__link"
              [href]="item.href"
              [target]="item.target ?? '_blank'"
              rel="noopener noreferrer"
              (click)="closeMenu()"
            >
              {{ item.label }}
            </a>
          }
        }
      </div>

      <div class="header__login" aria-label="Header action buttons">
        @if (menuOpen()) {
          <app-button fullWidth [href]="`${environment.appUrl}/auth/register`" (click)="closeMenu()"
            >Get started</app-button
          >
        } @else {
          <app-button
            variant="secondary"
            [href]="`${environment.appUrl}/auth/login`"
            (click)="closeMenu()"
            >Sign in</app-button
          >
        }
      </div>
    </nav>
  </div>
</header>
